import style from './Explore.module.css';
import { useSelector, useDispatch } from 'react-redux';
import { Oval } from 'react-loader-spinner';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Footer from '../../Components/Footer/Footer';
import BountyTile from '../../Components/BountyTile/BountyTile';
import NewsLetter from '../../Components/NewsLetter/NewsLetter';
import { allBounty } from '../../actions/bounty.action';

const Explore = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState('newest');
  const { bounty, loading, success } = useSelector(
    (state) => state.getAllBountyReducer
  );

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    dispatch(allBounty());
  }, [dispatch]);

  const getSortedBounties = () => {
    if (!bounty) return [];
    const arr = [...bounty];
    if (filter === 'newest') return arr.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    if (filter === 'oldest') return arr.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    if (filter === 'high') return arr.sort((a, b) => b.max_bounty - a.max_bounty);
    if (filter === 'low') return arr.sort((a, b) => a.max_bounty - b.max_bounty);
    return arr;
  };

  return (
    <>
      <div className={style.Explore}>
        <div className={style.Explore_Heading}>
          <h1>Explore Bounties</h1>
          <div className={style.Explore_Flex}>
            <div className={style.Explore_All}>All Bounties</div>
            <div className={style.Explore_Select}>
              <select className='minimal' value={filter} onChange={(e) => setFilter(e.target.value)}>
                <option value='newest'>Newest to oldest</option>
                <option value='oldest'>Oldest to newest</option>
                <option value='high'>$High to $low</option>
                <option value='low'>$Low to $high</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div className={style.Explore}>
        <div style={{ marginTop: '100px' }}>
          {!loading && success ? (
            bounty.length !== 0 ? (
              getSortedBounties().map((b) => {
                return <BountyTile key={b._id} bounty={b} />;
              })
            ) : (
              <div className={style.Center} style={{ fontWeight: '500' }}>
                No bounties found!
              </div>
            )
          ) : (
            <div className={style.Center}>
              <Oval
                ariaLabel='loading-indicator'
                height={80}
                width={80}
                strokeWidth={5}
                color='white'
                secondaryColor='purple'
              />
            </div>
          )}
        </div>
      </div>
      <NewsLetter />
      <Footer />
    </>
  );
};

export default Explore;
